import React, { useState } from 'react'

const ModalSignup = (props) => {

    return (
        <div
            data-bs-keyboard="false"
            className={`modal fade ${props.show ? 'show' : ''}`}
            id="select_modal"
            data-backdrop="static"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
            style={{ display: props.show ? "block" : "none" }}
        >
            <div
                className="modal-dialog modal-dialog-centered"
                role="document"
                style={{ maxWidth: 600 }}
            >
                <div className="modal-content">
                    {props.modalHeader &&
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">{props.title}</h5>
                            <button
                                type="button"
                                className="close"
                                aria-label="Close"
                                onClick={() => props.closeModal()}
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    }
                    <div className="modal-body">
                        {props.modalLoader &&
                            <div className='d-flex justify-content-center'>
                                <div className="spinner-border text-success" role="status">
                                    <span className="sr-only">Loading...</span>
                                </div>
                            </div>
                        }
                        {props.modalBody}
                    </div>
                    {props.modalFooter &&
                        <div className="modal-footer">
                            {props.modalFooter}
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}

export default ModalSignup